// axiosInstance.js
import axios from "axios";
// http://117.50.127.143  http://47.93.29.254
//https://www.aijfeng.com
const instance = axios.create({
  baseURL: "/jfai", // 这里是相对于代理地址的路径，如果您在 proxy 中设置的是 'http://localhost:5000'，那么实际的请求地址会是 'http://localhost:5000/api'
  timeout: 15000, // 请求超时时间（毫秒）
  headers: {
    "Content-Type": "application/json",
  },
});

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    // 假设 '12312313' 是您的tokenId，或者您可以从sessionStorage中获取它
    const tokenId = sessionStorage.getItem("token"); // 或者 sessionStorage.getItem('token');
    // 如果tokenId存在，则添加到请求头中
    if (tokenId) {
      config.headers["Authorization"] = `${tokenId}`;
    }

    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么，比如根据状态码进行不同的处理
    return response;
  },
  (error) => {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default instance;
